import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react';

// Shadcn components
import { Button } from "@/components/ui/button";

// Icons
import { AlertCircle, Home } from "lucide-react";

const Error = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const posthog = usePostHog();
    const errorCode = location.state?.errorCode || 404; // Default to 404 if no error code is passed

    useEffect(() => {
        document.title = `Error ${errorCode}`;
        
        // Track error page views with PostHog
        if (posthog) {
            posthog.capture('error_page_accessed', {
                error_code: errorCode,
                error_message: getErrorMessage(),
                current_path: location.pathname,
                referrer: document.referrer || 'direct',
                user_agent: navigator.userAgent,
                timestamp: new Date().toISOString()
            });
        }
    }, [errorCode, posthog, location.pathname]);

    const getErrorMessage = () => {
        switch (errorCode) {
            case 404:
                return "The page you're looking for doesn't exist or has been moved.";
            case 403:
                return "You don't have permission to access this page.";
            case 500:
                return "Something went wrong on our end. Please try again later.";
            default:
                return "An unexpected error occurred.";
        }
    };

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
            <div className="w-full max-w-2xl space-y-8 text-center">
                <div className="flex items-center justify-center mb-8">
                    <AlertCircle className="h-16 w-16 text-destructive" />
                </div>
                <h1 className="text-4xl font-bold">Error {errorCode}</h1>
                <p className="text-xl text-muted-foreground">
                    {getErrorMessage()}
                </p>
                <div className="flex justify-center my-12">
                    <img 
                        src="/branding/TriEvents_Logo.png" 
                        alt="TriEvents Logo" 
                        className="w-64 h-auto"
                    />
                </div>
                <Button
                    onClick={() => navigate('/auth')}
                    className="gap-2 text-base px-6 py-2"
                    size="lg"
                >
                    <Home className="h-5 w-5" />
                    Return Home
                </Button>
            </div>
        </div>
    );
};

export default Error;
